/**
 * True quando libs/acp roda dentro do shell unificado (apps/shell), que seta
 * window.__ACP_HOST__ = "shell" via inline script no index.html antes de
 * qualquer bundle executar. Apps standalone (ac, newco) nunca setam a flag.
 */
export const isShellHost = (): boolean =>
	(window as Window & { __ACP_HOST__?: string }).__ACP_HOST__ === "shell";
